/**
 * This module contains JS language extensions. The current approach is to create ponyfills rather
 * than polyfills.
 */

/**
 * Ponyfill for Object.entries (not supported by node until version 12).
 * Adapted from https://github.com/feross/fromentries
 *
 * @param entries          list of key/value pairs
 * @return object with keys and values provided
 *
 * TODO: figure out how to type Iterator
 */

// @ts-expect-error
// eslint-disable-next-line
export const fromEntries = (entries: Iterator): Record<string, any> => {
  if (Object.fromEntries) {
    return Object.fromEntries(entries);
  }
  return [...entries].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
};

/**
 * Checking if value is falsy. Exists for readability reasons.
 *
 * @param condition — condition to check.
 */
export const isFalsy = (condition: unknown): boolean => !condition;
